import type { ApiResponseEnvelope, RequestContext } from '../fetch/apiClient';
import { newToken } from './newToken';
import { requestError } from './requestError';

export function responseCallbacks(
  respBody: ApiResponseEnvelope<unknown>,
  respHeaders: Record<string, string>,
  request: RequestContext,
): void {
  newToken(respBody, respHeaders, request);
  requestError(respBody, respHeaders, request);
}
